import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderGridOtherActionsImport: {
    description: 'orderGridOtherActions.importOrders',
    defaultMessage: 'Import Orders',
    id: 'rj0Asc',
  },
  orderGridOtherActionsAddToBatch: {
    description: 'orderGridOtherActions.orderGridOtherActionsAddToBatch',
    defaultMessage: 'Add to Batch',
    id: 'rjRrV4',
  },
  orderGridOtherActionsCancelOrder: {
    description: 'orderGridOtherActions.cancelOrder',
    defaultMessage: 'Cancel',
    id: 'JqtHNr',
  },
  orderGridOtherActionsCombine: {
    description: 'orderGridOtherActions.combineShipments',
    defaultMessage: 'Combine Shipments',
    id: 'DIfcZN',
  },
  orderGridOtherActionsMarkShipped: {
    description: 'orderGridOtherActions.markShipped',
    defaultMessage: 'Mark As Shipped',
    id: 'pB9AXb',
  },
  orderGridOtherActionsAutoCreateBatches: {
    description: 'orderGridOtherActions.autoCreateBatches',
    defaultMessage: 'Auto Create Batches',
    id: 'cSMQow',
  },
  autoBatchingDisabledReason: {
    description: 'orderGridOtherActions autoCreateBatches disabled reason',
    defaultMessage: 'This feature is not enabled for this account',
    id: 'mrRCS8',
  },
  cancelDisabledReason: {
    description: 'otherActionsMenu.cancelDisabledReason',
    defaultMessage: 'One or more of the selected orders is in a status that does not support Cancellation.',
    id: '9Uw+vo',
  },
  orderGridOtherActionsExport: {
    description: 'orderGridOtherActions.exportOrders',
    defaultMessage: 'Export Orders',
    id: 'EX88tV',
  },
  orderGridOtherActionsManagePresets: {
    description: 'orderGridOtherActions.managePresets',
    defaultMessage: 'Manage Presets',
    id: 'hDzxxI',
  },
  orderGridOtherActionsMarkShippedBulk: {
    description: 'orderGridOtherActions.markShippedBulk',
    defaultMessage: 'Mark As Shipped Bulk',
    id: 'vdVxGa',
  },
  orderGridOtherActionsFulfillmentCancelOrder: {
    description: 'orderGridOtherActions.cancelOrder',
    defaultMessage: 'Cancel Order',
    id: 'wFV6r7',
  },
  orderGridOtherActionsRefreshSelectedOrders: {
    id: 'XGe5k9',
    defaultMessage: 'Refresh Selected Orders',
    description: 'Action to refresh only selected orders from their marketplaces',
  },
  refreshSelectedOrdersUnsupportedMarketplace: {
    id: '+jp1VZ',
    defaultMessage: 'Selective refresh is limited to orders from Shopify.',
    description: 'Tooltip shown when refresh selected orders is disabled due to unsupported marketplace',
  },
  orderGridOtherActionsBarcodeSearch: {
    description: 'orderGridOtherActions.barcodeSearch',
    defaultMessage: 'Barcode Search',
    id: '3jgSPO',
  },
  shipTogetherRestrictedReason: {
    description: 'reason for disabled split ship action',
    defaultMessage: 'Combining orders is restricted for one or more of the selected orders.',
    id: 'a75qIX',
  },
  orderGridOtherActionsSplit: {
    description: 'orderGridOtherActions.splitOrder',
    defaultMessage: 'Show Split Ship Actions',
    id: 'J9FIOj',
  },
  splitShipRestrictedReason: {
    description: 'reason for disabled split ship action',
    defaultMessage: 'Splitting is restricted for the selected order.',
    id: 'Ges3tY',
  },
  splitShipNotAllowedForMultipleOrders: {
    description: 'Reason for disabled split ship action when selecting multiple orders',
    defaultMessage: 'Splitting is disabled when selecting multiple orders.',
    id: 'i0aVg/',
  },
  splitShipNotAllowedForOneItemOrders: {
    description: 'Reason for disabled split ship action when selecting an order with only one item',
    defaultMessage: 'Splitting is disabled when selecting an order with only one item.',
    id: 'bXG1gz',
  },
  orderGridOtherActionsValidateAddress: {
    description: 'orderGridOtherActions.validateAddress',
    defaultMessage: 'Validate Address',
    id: 'fXKjv4',
  },
  orderGetRate: {
    description: 'orderGridOtherActions.getRate',
    defaultMessage: 'Get Rate',
    id: 'vYJl60',
  },
  isDemoDisabledMessage: {
    description: "Disabled message for actions in 'other action' menu for demo orders",
    defaultMessage: 'This action is disabled for Demo Orders',
    id: '/9nN8V',
  },
});
